import { useState } from "react";
import { checkShiftCodeStatus } from "../services/shiftService";

const useShiftCodeValidation = () => {

    const [shiftCodeStatus, setShiftCodeStatus] = useState([]);

    const fetchShiftCodeStatus = async (shiftCode = null) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1, p_code: shiftCode, };

        try {
            const data = await checkShiftCodeStatus(para);
            if (data && data.length > 0) {
                setShiftCodeStatus(data[0].shift_code_status);

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    }

    const checkShiftCode = async (shiftCode) => {
        if (shiftCode !== '') {
            await fetchShiftCodeStatus(shiftCode);
        } else {
            setShiftCodeStatus(false);
        }

    }

    return { shiftCodeStatus, setShiftCodeStatus, checkShiftCode };

}
export default useShiftCodeValidation;